/* projects/speaker-platform/src/app/organisms/sidebar/sidebar.component.scss */
.sidebar {
  width: 100%;
  height: 100%;
  padding: 18px 36px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 18px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
}
.sidebar__backtoprod {
  position: absolute;
  top: 4px;
  left: 16px;
}
.sidebar--collapsed {
  height: 145px;
}
.sidebar--collapsed .sidebar__logo {
  transform: translateX(-55px) translateY(35px);
}
.sidebar__collapsebutton {
  position: absolute;
  right: 16px;
  top: 4px;
}
.sidebar__collapsebutton button {
  background: none;
  border: 0;
  font-size: 30px;
}
.sidebar__logo {
  margin-bottom: 60px;
  text-align: center;
  transition: all 0.3s;
  cursor: pointer;
}
.sidebar__user {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 32px;
}
.sidebar__usergreetings {
  margin-top: 16px;
  font-size: 14px;
  font-style: italic;
  color: #818181;
}
.sidebar__username {
  font-weight: 700;
}
/*# sourceMappingURL=sidebar.component-SMC2UYUY.css.map */
